<template>
  <v-container>
    <v-row class="mb-0 py-0">
      <v-spacer />
      <v-col cols="12" md="8">
        <v-slider
          v-model.number="currentMomentum"
          :min="momentumMin"
          ticks="always"
          thumb-label="always"
          :tick-labels="momentumRange"
          :max="characterMax"
        />
      </v-col>
      <v-spacer />
    </v-row>

    <v-row>
      <v-col cols="12">
        <v-row justify="center" align="center" class="text-center">
          <v-col class="text-right">
            <v-btn fab text small @click="decrementMomentum">
              <v-icon>mdi-minus</v-icon>
            </v-btn>
          </v-col>
          <v-col>
            <span>
              Momentum
            </span>
          </v-col>
          <v-col class="text-left">
            <v-btn fab text small @click="incrementMomentum">
              <v-icon>mdi-plus</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row>
      <v-expansion-panels popout>
        <v-expansion-panel>
          <v-expansion-panel-header>
            Momentum Tools
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-col>
              <v-row>
                <v-col cols="6">
                  <v-text-field v-model.number="characterMax" label="Max" />
                </v-col>
                <v-col cols="6">
                  <v-text-field v-model.number="reset" label="Reset" />
                </v-col>
              </v-row>
            </v-col>
            <v-col>
              <v-btn
                :disabled="currentMomentum <= reset"
                @click="resetMomentum"
              >
                Burn
                <v-icon right>mdi-fire</v-icon>
              </v-btn>
            </v-col>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-row>
  </v-container>
</template>

<script>
  import {mapGetters} from 'vuex';
  export default {
    name: 'VitalField',
    props: ['label', 'value'],
    components: {},
    computed: {
      ...mapGetters('character', ['momentumMax', 'momentumMin', 'momentumRange']),
      currentMomentum: {
        get() {
          return this.$store.getters['character/momentumCurrent'];
        },
        set(val) {
          this.$store.dispatch('character/setMomentum', val);
        },
      },
      characterMax: {
        get() {
          return this.$store.getters['character/momentumCharacterMax'];
        },
        set(val) {
          this.$store.dispatch('character/setCharacterMaxMomentum', val);
        },
      },
      reset: {
        get() {
          return this.$store.getters['character/momentumReset'];
        },
        set(val) {
          this.$store.dispatch('character/setMomentumReset', val);
        },
      },
    },

    methods: {
      resetMomentum() {
        this.$store.dispatch('character/resetMomentum');
      },
      incrementMomentum() {
        this.$store.dispatch('character/setMomentum', this.currentMomentum + 1);
      },
      decrementMomentum() {
        this.$store.dispatch('character/setMomentum', this.currentMomentum - 1);
      },
    },
  };
</script>
